import { SinglePermissionModel } from "../shared/models/IPermission";
import { PermissionReport } from "../shared/models/report.permission.model";
import { MapSinglePermissionModelToPermissionAdmin } from "../shared/mapper/single-permission-model-to-permission-admin.mapper";
import { share } from "rxjs/operators";

export function getViewModleForPermissions(model: SinglePermissionModel[], /*isEditingMode: boolean,*/ viewMode: number /*= ViewPermission.FullAccess*/, groupPermission?: number[]): PermissionReport {
    let permissionReport = new PermissionReport();
    let viewLobbyActivity = model.find(p => p?.permissionId === 60);
    let editLobbyActivity = model.find(p => p?.permissionId === 61);
    let shareTemplateLobbyActivity = model.find(p => p?.permissionId === 87);
    let deleteTemplateLobbyActivity = model.find(p => p?.permissionId === 89);
    let viewStaffSignInOutReport = model.find(p => p?.permissionId === 91);

    
    permissionReport.selectAllPermissionReport=
    {
        Selected:true,
        Enabled:true,
        Id:997,
        DisplayName:''
    }
    permissionReport.LobbyActivity = {
        selectAll: false,
        viewLobbyActivity: MapSinglePermissionModelToPermissionAdmin(viewLobbyActivity, 60, viewMode, groupPermission),
        editLobbyActivity: MapSinglePermissionModelToPermissionAdmin(editLobbyActivity, 61, viewMode, groupPermission),
        shareTemplateLobbyActivity: MapSinglePermissionModelToPermissionAdmin(shareTemplateLobbyActivity, 87, viewMode, groupPermission),
        deleteTemplateLobbyActivity: MapSinglePermissionModelToPermissionAdmin(deleteTemplateLobbyActivity, 89, viewMode, groupPermission),
        viewStaffSignInOutReport: MapSinglePermissionModelToPermissionAdmin(viewStaffSignInOutReport, 91, viewMode, groupPermission),
    }

    let viewEditLobby = model.find(p => p?.permissionId === 65);
    let editLobbyReport = model.find(p => p?.permissionId === 66);
    let shareTemplateLobbyEditReports = model.find(p => p?.permissionId === 88);
    let deleteTemplateLobbyEditReports = model.find(p => p?.permissionId === 90);


    permissionReport.LobbyEdit = {
        selectAll: false,
        viewLobbyEditReports: MapSinglePermissionModelToPermissionAdmin(viewEditLobby, 65, viewMode, groupPermission),
        editLobbyEditReports: MapSinglePermissionModelToPermissionAdmin(editLobbyReport, 66, viewMode, groupPermission),
        shareTemplateLobbyEditReports: MapSinglePermissionModelToPermissionAdmin(shareTemplateLobbyEditReports, 88, viewMode, groupPermission),
        deleteTemplateLobbyEditReports: MapSinglePermissionModelToPermissionAdmin(deleteTemplateLobbyEditReports, 90, viewMode, groupPermission),
    }

    permissionReport.LobbyActivity.selectAll = permissionReport.LobbyActivity.viewLobbyActivity.Selected
        && permissionReport.LobbyActivity.shareTemplateLobbyActivity.Selected
        && permissionReport.LobbyActivity.deleteTemplateLobbyActivity.Selected
        && permissionReport.LobbyActivity.viewStaffSignInOutReport.Selected;

    permissionReport.LobbyEdit.selectAll = permissionReport.LobbyEdit.viewLobbyEditReports.Selected
        && permissionReport.LobbyEdit.editLobbyEditReports.Selected
        && permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Selected
        && permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Selected;

    permissionReport.selectAllPermissionReport.Selected = permissionReport.LobbyActivity.selectAll && permissionReport.LobbyEdit.selectAll

    return permissionReport;
}

export function setSelectAllReportStatus(permissionReport: PermissionReport): boolean {
    
    let enabled = checkLobbyActivityReportStatus(permissionReport)
    && checkLobbyEditorReportStatus(permissionReport)

    return enabled;
}

//Check for disabled and un-check fields in each sub category of analytics permissions section

function checkLobbyActivityReportStatus(permissionReport: PermissionReport): boolean {

    let enabled = false;

    let viewLobbyActivity = !permissionReport.LobbyActivity.viewLobbyActivity.Enabled;
    let shareTemplateLobbyActivity = !permissionReport.LobbyActivity.shareTemplateLobbyActivity.Enabled;

    let viewStaffSign = !permissionReport.LobbyActivity.viewStaffSignInOutReport.Enabled;
    let deleteTemplateLobbyActivity= !permissionReport.LobbyActivity.deleteTemplateLobbyActivity.Enabled;
    if (viewLobbyActivity || shareTemplateLobbyActivity || viewStaffSign || deleteTemplateLobbyActivity) {

        enabled = false;
    } else {
        enabled = true;
    }

    return enabled;
}

function checkLobbyEditorReportStatus(permissionReport: PermissionReport): boolean {

    let enabled = false;

    let viewLobbyEditReports = !permissionReport.LobbyEdit.viewLobbyEditReports.Enabled;
    let editLobbyEditReports = !permissionReport.LobbyEdit.editLobbyEditReports.Enabled;
    let shareTemplateLobbyEditReports = !permissionReport.LobbyEdit.shareTemplateLobbyEditReports.Enabled;
    let deleteTemplateEditReport = !permissionReport.LobbyEdit.deleteTemplateLobbyEditReports.Enabled;

    if (viewLobbyEditReports || editLobbyEditReports || shareTemplateLobbyEditReports || deleteTemplateEditReport) {
        enabled = false;
    } else {
        enabled = true;
    }

    return enabled;
}